<template>
  <button
    @click.prevent="$emit('change', !favorite)"
    type="button"
    :title="titleText"
    class="vacancy-favorite-btn"
    :data-active="favorite"
  >
    {{ titleText }}
    <SvgIcon icon="favorite" :size="24" />
  </button>
</template>

<script>
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default {
  name: 'VacancyFavoriteBtn',
  components: {
    SvgIcon,
  },
  model: {
    prop: 'favorite',
    event: 'change',
  },
  props: {
    favorite: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    favorite(value) {
      this.$emit('update:favorite', value);
    },
  },
  computed: {
    titleText() {
      return this.favorite ? 'Удалить из избранного' : 'Добавить в избранное';
    },
  },
};
</script>
